import React, { useState } from "react";
import UsersService from "../../../services/v2/management/users-service";

const UserDelete = ({ user, close, refresh }) => {
  const [error, setError] = useState(null); // Estado para manejar errores

  const handleDelete = async () => {
    try {
      await UsersService.deleteById(user._id);
      refresh();
      close();
    } catch (err) {
      console.error("Failed to delete user:", err);
      setError(
        err.response?.data?.message ||
          "Failed to delete user. Please try again."
      );
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-lg flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Delete User
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Are you sure you want to delete <strong>{user?.name}</strong>?
        </p>
        {error && (
          <div className="mt-4 bg-red-100 text-red-600 px-4 py-2 rounded-md text-sm font-medium">
            {error}
          </div>
        )}
        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={close}
            className="bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 py-2 px-4 rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDelete;
